import * as API from './index'
export default {
	//产品初始化
	getInitQuery:params=>{
		return API.POST('/api/client/product/pcInitProductCenter', params)
	},
	//产品查询
	getConditionQuery:params=>{  
		return API.POST('/api/client/product/pcConditionQuery', params)
	},
    //提交input
	getApplyJoin:params=>{  
		return API.POST('/api/client/member/applyJoin', params)
	},
	   //首页轮播
	getPcContent:params=>{   
		return API.POST('/api/client/home/getPcContent', params)
	}
} 


// WEBPACK FOOTER //
// ./src/components/api/home.js